<template>
  <div class="meter-reading clearfix" v-loading.fullscreen.lock="loadingMark">
    <div class="charts_header clearfix">
      <div class="header_content clearfix">
        <div class="left">
          抄表 {{ common.timestampToTime(dataTime.getTime()) }}
        </div>
        <div class="right">
          <div class="right_right">
            <div class="export" @click="exportClick">导出</div>
            <div class="print" @click="closeView">
              <i class="el-icon-circle-close" style="color: #5087e4;font-size: 18px;margin-right: 4px;"></i>
              关闭
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="charts_content clearfix">
      <div class="meter-table-wrap">
        <div class="title-border"></div>
        <el-table
          :data="tableData"
          border
          :highlight-current-row="true"
          tooltip-effect="dark"
          class="meter-table">
          <el-table-column :label="reportTitle" min-width="896" align="center">
            <el-table-column :label="subTitle(reportData)" min-width="896" align="right">
              <el-table-column prop="index" label="序号" width="46"></el-table-column>
              <el-table-column prop="deviceName" label="设备名" min-width="120"></el-table-column>
              <el-table-column prop="propertyName" label="属性名" min-width="120"></el-table-column>
              <!-- <el-table-column prop="period" label="周期" min-width="90"></el-table-column> -->
              <el-table-column prop="startValue" label="期初表码" min-width="120"></el-table-column>
              <el-table-column prop="startTime" label="期初表码时间" min-width="160"></el-table-column>
              <el-table-column prop="endValue" label="期末表码" min-width="120"></el-table-column>
              <el-table-column prop="endTime" label="期末表码时间" min-width="160"></el-table-column>
              <el-table-column prop="dosage" label="用量" min-width="110"></el-table-column>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  var XLSX = require('xlsx')
  export default {
    name: 'meterReading',
    data() {
      return {
        dataTime: new Date(),
        loadingMark: false,
        reportData: {},
        timeData: {},
        beginTime: null,
        endTime: null,
        tableData: [],
        deviceNameCache: {},
        propertyListCache: {},
        propertyNameCache: {}
      }
    },
    created() {
      this.$parent.ChangeHeaderShow()
      let reportData = localStorage.getItem('reportData')
      if(reportData){
        reportData = JSON.parse(reportData)
        this.reportData = reportData.reportData || {}
        this.timeData = reportData.timeData || {}
      }
      this.initData()
    },
    mounted() {
      document.title = `抄表 ${this.common.timestampToTime(this.dataTime.getTime())}`
    },
    computed: {
      reportTitle(){
        return this.reportData.title || this.reportData.name || ''
      }
    },
    methods: {
      closeView(){
        window.close()
      },
      initData(){
        let meterId = this.reportData.id
        if(!meterId){
          return
        }
        let beginFrame = this.getBeginFrame(this.timeData.beginFrame)
        let endFrame = this.getEndFrame(this.timeData.endFrame || this.timeData.beginFrame)
        this.beginTime = beginFrame
        this.endTime = endFrame
        this.loadingMark = true
        this.get('/Meter/getData', { meterId, beginFrame, endFrame }).then(async res=>{
          if(res.success){
            let list = res.result || []
            this.tableData = await this.formatTableData(list)
          }else{
            this.$message({
              message: `获取抄表历史数据失败：${res.message}`,
              type: 'warning'
            })
          }
        }).finally(()=>{
          this.loadingMark = false
        })
      },
      async formatTableData(list){
        let data = []
        for(let i in list){
          let item = list[i]
          let deviceName = await this.getDeviceName(item.deviceCode)
          let propertyName = await this.getPropertyName(item.deviceCode, item.propertyCode)
          data.push({
            index: Number(i) + 1,
            deviceName: deviceName || '-',
            propertyName: propertyName || '-',
            period: item.period,
            startValue: this.showValue(item.begin),
            startTime: this.formatTime(item.beginReadingTime),
            endValue: this.showValue(item.end),
            endTime: this.formatTime(item.endReadingTime),
            dosage: this.showValue(item.value)
          })
        }
        return data
      },
      async getDeviceName(deviceCode){
        if(!deviceCode){
          return ''
        }
        if(Object.prototype.hasOwnProperty.call(this.deviceNameCache, deviceCode)){
          return this.deviceNameCache[deviceCode]
        }
        let name = ''
        await this.get('/Device/getByCode', { code: deviceCode }).then(res=>{
          if(res.success && res.result){
            name = res.result.name || ''
          }
        })
        this.$set(this.deviceNameCache, deviceCode, name)
        return name
      },
      async getPropertyName(deviceCode, propertyCode){
        if(!deviceCode || !propertyCode){
          return ''
        }
        let cacheKey = `${deviceCode}_${propertyCode}`
        if(Object.prototype.hasOwnProperty.call(this.propertyNameCache, cacheKey)){
          return this.propertyNameCache[cacheKey]
        }
        let name = ''
        let propertyList = await this.getPropertyList(deviceCode)
        let property = propertyList.filter(item=>item.identifier == propertyCode)[0]
        if(property){
          name = property.name || ''
        }
        this.$set(this.propertyNameCache, cacheKey, name)
        return name
      },
      async getPropertyList(deviceCode){
        if(!deviceCode){
          return []
        }
        if(Object.prototype.hasOwnProperty.call(this.propertyListCache, deviceCode)){
          return this.propertyListCache[deviceCode]
        }
        let list = []
        await this.get('/ProductFeature/getByDeviceCode', { code: deviceCode }).then(res=>{
          if(res.success && res.result){
            let result = JSON.parse(res.result)
            list = result.properties || []
          }
        })
        this.$set(this.propertyListCache, deviceCode, list)
        return list
      },
      getBeginFrame(value){
        let date = new Date(Number(value))
        let timeWindow = Number(this.timeData.timeWindow || this.reportData.timeWindow || this.reportData.categoryId || 3)
        if(timeWindow == 7){
          return new Date(date.getFullYear(), 0, 1, 0, 0, 0).getTime()
        }
        if(timeWindow == 5){
          return new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime()
        }
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0).getTime()
      },
      getEndFrame(value){
        let date = new Date(Number(value))
        let timeWindow = Number(this.timeData.timeWindow || this.reportData.timeWindow || this.reportData.categoryId || 3)
        if(timeWindow == 7){
          return new Date(date.getFullYear(), 11, 31, 23, 59, 59).getTime()
        }
        if(timeWindow == 5){
          return new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime()
        }
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59).getTime()
      },
      formatTime(value){
        if(value == null || value === ''){
          return '-'
        }
        return this.common.timestampToTime(Number(value))
      },
      showValue(value){
        if(value == null || value === ''){
          return '-'
        }
        return value
      },
      subTitle(report){
        let text = '', start = '', end = ''
        if(report.hasTime || report.hasDate){
          start = this.formatTime(this.beginTime)
          end = this.formatTime(this.endTime)
        }
        text = start || end ? `${start} - ${end}` : ''
        let groupName = report.groupName || report.Groupname
        if(report.hasGroup && groupName){
          text = text ? `${groupName} ${text}` : groupName
        }
        return text
      },
      exportClick() {
        let dataArr = [
          ['序号', '设备名', '属性名',  '期初表码', '期初表码时间', '期末表码', '期末表码时间', '用量']
        ]
        this.tableData.forEach(item=>{
          dataArr.push([
            item.index,
            item.deviceName,
            item.propertyName,
            // item.period,
            item.startValue,
            item.startTime,
            item.endValue,
            item.endTime,
            item.dosage
          ])
        })
        dataArr.unshift([this.subTitle(this.reportData)])
        dataArr.unshift([this.reportTitle])
        let wb = XLSX.utils.book_new()
        let ws = XLSX.utils.aoa_to_sheet(dataArr)
        XLSX.utils.book_append_sheet(wb, ws, '抄表')
        XLSX.writeFile(wb, this.changeTime(new Date().getTime()) + '.xlsx')
      }
    }
  }
</script>

<style scoped>
  .meter-reading {
    width: 100%;
    min-height: 100%;
    position: relative;
    background-color: #f3f3f3;
    max-height: 100%;
    overflow: auto;
  }

  .charts_header {
    width: 100%;
    height: 75px;
    float: left;
    border-bottom: 1px solid #d8d8d8;
    line-height: 75px;
    background: #fff;
    position: relative;
    z-index: 2;
  }

  .header_content {
    width: 100%;
    float: left;
    text-align: left;
  }

  .header_content .left {
    float: left;
    color: #363636;
    font-size: 14px;
    margin-left: 53px;
  }

  .header_content .right {
    float: right;
    padding-right: 126px;
    font-size: 13px;
    text-align: left;
  }

  .header_content .right .right_right {
    float: left;
    color: #5087e4;
  }

  .export,
  .print {
    cursor: pointer;
    width: 48px;
    text-align: right;
    float: left;
  }

  .export {
    background: url(../../assets/image/createdExecl/export.png) no-repeat left;
    margin-right: 23px;
  }

  .print {
    display: flex;
    align-items: center;
    /* background: url(../../assets/image/createdExecl/print.png) no-repeat left; */
  }

  .charts_content {
    width: 21cm;
    min-height: 29.7cm;
    position: absolute;
    top: 76px;
    left: 0;
    right: 0;
    margin: auto;
    background: #fff;
  }

  .meter-table-wrap {
    width: 718px;
    margin: 40px auto 0;
  }

  .meter-table {
    width: 100%;
  }

  .title-border {
    width: 4px;
    height: 13px;
    margin-bottom: 13px;
    background: #00cccd;
  }

  .meter-table >>> .el-table__header th {
    height: 38px;
    padding: 0;
    background: #f5f7fa;
    color: #7d8792;
    font-weight: bold;
  }

  .meter-table >>> .el-table__body td {
    height: 36px;
    padding: 0;
    color: #2c3e50;
  }

  .meter-table >>> .el-table th,
  .meter-table >>> .el-table td {
    border-color: #e6ebf2;
  }

  .meter-table >>> .cell {
    line-height: 36px;
    padding-left: 8px;
    padding-right: 8px;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/ReportForms/meterReading.vue